import { useState, useEffect } from "react";
import { Link } from "react-router-dom";

interface NavbarProps {
  onRandevuClick?: () => void;
}

export default function Navbar({ onRandevuClick }: NavbarProps) {
  const [scrolled, setScrolled] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => setScrolled(window.scrollY > 60);
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const scrollTo = (id: string) => {
    const el = document.getElementById(id);
    if (el) el.scrollIntoView({ behavior: "smooth" });
    setMenuOpen(false);
  };

  return (
    <nav
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-500 ${
        scrolled
          ? "bg-[#1A0F0A]/97 backdrop-blur-md border-b border-[#E8B86D]/15"
          : "bg-transparent"
      }`}
    >
      {/* Top accent line — only when not scrolled */}
      {!scrolled && (
        <div className="h-0.5 bg-gradient-to-r from-transparent via-[#E8B86D]/60 to-transparent" />
      )}

      <div className="max-w-7xl mx-auto px-6 md:px-10 flex items-center justify-between h-20">
        {/* Logo */}
        <Link to="/" className="flex items-center gap-3 cursor-pointer">
          <img
            src="https://public.readdy.ai/ai/img_res/a5d1b8cb-aaa2-4cf9-95cd-76f3854cad51.png"
            alt="Elora Beauty Lounge"
            className="h-10 w-auto object-contain brightness-0 invert"
          />
        </Link>

        {/* Desktop Nav */}
        <div className="hidden md:flex items-center gap-8">
          {[
            { label: "Ana Sayfa", id: "hero" },
            { label: "Kampanyalar", id: "kampanyalar" },
            { label: "Yorumlar", id: "yorumlar" },
            { label: "SSS", id: "sss" },
            { label: "İletişim", id: "final-cta" },
          ].map((item) => (
            <button
              key={item.id}
              onClick={() => scrollTo(item.id)}
              className="text-sm font-medium tracking-wide transition-colors duration-200 cursor-pointer whitespace-nowrap text-white/70 hover:text-[#E8B86D]"
              style={{ fontFamily: "'Inter', sans-serif" }}
            >
              {item.label}
            </button>
          ))}
          <Link
            to="/hizmetler"
            className="text-sm font-medium tracking-wide transition-colors duration-200 cursor-pointer whitespace-nowrap text-white/70 hover:text-[#E8B86D]"
            style={{ fontFamily: "'Inter', sans-serif" }}
          >
            Hizmetler
          </Link>
        </div>

        {/* CTA Button */}
        <div className="hidden md:flex items-center gap-3">
          <button
            onClick={onRandevuClick}
            className="bg-[#E8B86D] text-[#1A0F0A] text-sm font-bold px-6 py-2.5 rounded-full hover:bg-[#F5D08A] transition-all duration-200 cursor-pointer whitespace-nowrap"
            style={{ fontFamily: "'Inter', sans-serif" }}
          >
            Randevu Al
          </button>
        </div>

        {/* Mobile Hamburger */}
        <button
          className="md:hidden flex flex-col gap-1.5 cursor-pointer p-2"
          onClick={() => setMenuOpen(!menuOpen)}
          aria-label="Menü"
        >
          <span className="block w-6 h-0.5 bg-white transition-all duration-300" />
          <span className="block w-6 h-0.5 bg-white transition-all duration-300" />
          <span className="block w-6 h-0.5 bg-white transition-all duration-300" />
        </button>
      </div>

      {/* Mobile Menu */}
      {menuOpen && (
        <div className="md:hidden bg-[#1A0F0A]/98 backdrop-blur-md border-t border-[#E8B86D]/15 px-6 py-5 flex flex-col gap-4">
          {[
            { label: "Ana Sayfa", id: "hero" },
            { label: "Kampanyalar", id: "kampanyalar" },
            { label: "Yorumlar", id: "yorumlar" },
            { label: "SSS", id: "sss" },
            { label: "İletişim", id: "final-cta" },
          ].map((item) => (
            <button
              key={item.id}
              onClick={() => scrollTo(item.id)}
              className="text-white/70 text-base font-medium text-left cursor-pointer hover:text-[#E8B86D] transition-colors"
            >
              {item.label}
            </button>
          ))}
          <Link
            to="/hizmetler"
            onClick={() => setMenuOpen(false)}
            className="text-white/70 text-base font-medium text-left cursor-pointer hover:text-[#E8B86D] transition-colors"
          >
            Hizmetler
          </Link>
          <button
            onClick={() => { onRandevuClick?.(); setMenuOpen(false); }}
            className="bg-[#E8B86D] text-[#1A0F0A] text-sm font-bold px-6 py-3 rounded-full cursor-pointer whitespace-nowrap mt-1"
          >
            Randevu Al
          </button>
        </div>
      )}
    </nav>
  );
}